import { RootState } from "../../store";

export const currentStepSelector = (state: RootState) =>
  state.accountSetup.currentStep;
